import React from 'react';
import { ClockIcon, CreditCardIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Countdown } from '../Countdown';
import { PriceCard } from '../PriceCard';
import { Highlight } from '../Highlight';
import { paymentMethods } from '../../data/landing';
const assurances = [{
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: ZapIcon,
  label: 'Acceso en 5 minutos'
}, {
  icon: LockIcon,
  label: 'Pago 100% seguro'
}];
export function FinalCta() {
  return <section className="bg-ink px-5 py-16 md:py-24" data-id="element-109" data-mp="1iqeluvtd7mcz">
      <div className="mx-auto max-w-3xl text-center" data-id="element-110" data-mp="1ir7ygdf09631">
        <h2 className="text-3xl font-black uppercase leading-[1.05] tracking-tight text-heading md:text-5xl" data-id="element-111" data-mp="14qx430ehl9d4">
          Tu próximo lunes puede ser <Highlight data-id="element-112" data-mp="19pgrz6cn4v84">diferente.</Highlight>
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-lg text-body" data-id="element-113" data-mp="2z3n13r05iyoq">
          No necesitas esperar a que las cosas cambien. Necesitas un protocolo que te enseñe a HACER que cambien.
        </p>

        <p className="mt-12 flex items-center justify-center gap-2 text-sm font-black uppercase tracking-[0.15em] text-heading md:text-base" data-id="element-114" data-mp="28v260hf3ce1">
          <ClockIcon className="h-5 w-5 text-danger" aria-hidden="true" data-id="element-115" data-mp="3tewjurvw148n" />
          El precio cierra en:
        </p>
        <div className="mt-6" data-id="element-116" data-mp="b3j9dw6jz45h">
          <Countdown data-id="element-117" data-mp="703f36hyhfvy" />
        </div>

        <div className="mt-12 flex flex-col gap-10" data-id="element-118" data-mp="714q5ayz22do">
          <PriceCard subtitle="6 Tomos + 6 Bonos" idealFor="Quienes quieren recuperar enfoque de 7 a 30 días" ctaLabel="Quiero mi MegaPack ahora" originalPrice="$108.000" currentPrice="$38.990" data-id="element-119" data-mp="3ffn6dzz2go8d" />
        </div>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm font-semibold text-heading" data-id="element-120" data-mp="3og37x3w91lal">
          {assurances.map(({
          icon: Icon,
          label
        }) => <li key={label} className="flex items-center gap-2" data-id="element-121" data-mp="13q3zktbala7g">
              <Icon className="h-4 w-4 text-success" aria-hidden="true" data-id="element-122" data-mp="13oj85ck9y7dt" />
              {label}
            </li>)}
        </ul>
        <p className="mt-4 flex items-center justify-center gap-2 text-sm text-body" data-id="element-123" data-mp="ytdjw73eggmk">
          <CreditCardIcon className="h-4 w-4" aria-hidden="true" data-id="element-124" data-mp="3sl3iaygjejwv" />
          {paymentMethods}
        </p>
      </div>
    </section>;
}